var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('div',{ref:"labeling",staticClass:"labeling"},[_c('p',[_vm._v(_vm._s(_vm.labelData.order_sn))]),_c('p',[_vm._v("NO:"+_vm._s(_vm.labelData.sorting))]),_c('p',[_vm._v("Made in China")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }